<script setup lang="ts">
interface IProps {
  small?: boolean
}

const props = defineProps<IProps>()
const { small } = toRefs(props)
</script>

<script lang="ts">
export default defineComponent({
  name: 'TextV2',
})
</script>

<template>
  <span class="font-inter break-words" :class="small === true && 'small'">
    <slot />
  </span>
</template>

<style lang="scss" scoped>
span {
  &.small {
    font-size: 11.3px;
    line-height: 20px;
  }
}

.break-words {
  word-break: break-word;
}

.body-16 {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 175%;
}

.body-14 {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 175%;
}

.body-12 {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 175%;
}

.body-10 {
  font-family: "Inter", sans-serif;
  font-size: 10px;
  line-height: 175%;
}
</style>
